import React from "react";
import PowerIcon from "@material-ui/icons/PowerSettingsNew";
import Tooltip from "@material-ui/core/Tooltip/index";

export default function PowerButton({ id, status, onUpdateUserStatus }) {
  return (
    <Tooltip title={status ==="ACTIVE" ? "Aktiv" : status ==="INACTIVE" && "Deaktiv"} placement="top" className=" mr-2">
      <button
        aria-label={status ==="ACTIVE" ? "Aktiv" : status ==="INACTIVE" && "Deaktiv"}
        className={`btn btn-sm btn-icon btn-bg-light ${
          status ==="ACTIVE" ? "btn-text-success" :  status ==="INACTIVE" && "btn-text-danger"
        }`}
        onClick={() => onUpdateUserStatus(id, status)}
      >
        <PowerIcon />
      </button>
    </Tooltip>
  );
}
